export default __webpack_public_path__ + "static/articulo7-5574d72c34042e3e4119066208b9f90f.png";